import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

enum PROCESSING_STATE {
    SUCCESS = 'success',
    ERROR = 'error',
    PENDING = 'pending',
    PARSING = 'parsing',
}
@Component({
    selector: 'app-processing-loader',
    templateUrl: './processing-loader.component.html',
    styleUrl: './processing-loader.component.scss',
    standalone: false
})
export class ProcessingLoaderComponent implements OnInit {
    @Input() loadingMessage: string;
    @Input() status: string;

    PROCESSING_STATE = PROCESSING_STATE;
    progress: number = 0;
    ngOnInit() {
        if (this.status === PROCESSING_STATE.PENDING || this.status === PROCESSING_STATE.PARSING) {
            this.simulateProgress();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.['status']?.currentValue) {
            this.handleStatusChange(changes['status'].currentValue);
        }
    }

    private handleStatusChange(newStatus: string) {
        if (newStatus == PROCESSING_STATE.PARSING) {
            this.progress = 0;
            this.simulateProgress();
        }
        if (newStatus === PROCESSING_STATE.SUCCESS || newStatus === PROCESSING_STATE.ERROR) {
            this.progress = 100;
        }
    }

    private simulateProgress() {
        const totalTime = 3;
        const totalProgress = 95;
        const stepTime = totalTime / 95;

        const interval = setInterval(() => {
            if (this.progress < totalProgress) {
                this.progress += stepTime * 10;
            } else {
                clearInterval(interval);
            }
        }, stepTime * 1000);
    }
}
